import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Zap, ArrowRight, ArrowUpRight } from "lucide-react";
import api from "../lib/api";
import Reveal from "./Reveal";

export default function DealOfTheDay() {
  const [deal, setDeal] = useState(null);

  useEffect(() => {
    api.get("/deal-of-the-day")
      .then((r) => setDeal(r.data && r.data.product ? r.data : null))
      .catch(() => {});
  }, []);

  if (!deal) return null;

  const track = () => api.post("/track/click", { url: deal.url, product: deal.product, article_slug: deal.article_slug }).catch(() => {});

  return (
    <Reveal>
      <section data-testid="deal-of-the-day" className="border-y border-kinetic/40 bg-kinetic/[0.06]">
        <div className="max-w-[1440px] mx-auto px-5 lg:px-10 py-8 flex flex-col lg:flex-row lg:items-center gap-6 justify-between">
          <div className="flex items-start gap-4 min-w-0">
            <span className="w-11 h-11 bg-kinetic text-obsidian flex items-center justify-center shrink-0">
              <Zap size={20} />
            </span>
            <div className="min-w-0">
              <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-kinetic mb-2">
                Deal of the day — picked from today's pages
              </p>
              <a href={deal.url} target="_blank" rel="noopener noreferrer sponsored" onClick={track}
                data-testid="deal-product-link"
                className="font-display font-extrabold text-xl sm:text-2xl text-porcelain hover:text-kinetic transition-colors underline decoration-kinetic/40 underline-offset-4 break-words">
                {deal.product}
              </a>
              <p className="text-ash text-sm mt-2">
                From today's story:{" "}
                <Link to={`/article/${deal.article_slug}`} data-testid="deal-article-link" className="text-porcelain hover:text-kinetic transition-colors">
                  {deal.article_title}
                </Link>
                <span className="mx-2 text-ash/50">·</span>
                <Link to="/deals" data-testid="deal-vault-link" className="text-kinetic hover:text-porcelain transition-colors">
                  Past deals →
                </Link>
              </p>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-3 shrink-0">
            <Link to={`/article/${deal.article_slug}`} data-testid="deal-read-button"
              className="group border border-white/15 hover:border-kinetic/60 text-porcelain font-mono text-xs uppercase tracking-[0.18em] px-6 py-3.5 rounded-full flex items-center gap-2 transition-colors duration-300">
              Read the piece <ArrowRight size={14} className="text-kinetic group-hover:translate-x-1 transition-transform duration-300" />
            </Link>
            <a href={deal.url} target="_blank" rel="noopener noreferrer sponsored" onClick={track} data-testid="deal-amazon-button"
              className="group bg-kinetic text-obsidian font-mono text-xs uppercase tracking-[0.18em] font-medium px-6 py-3.5 rounded-full flex items-center gap-2 hover:bg-porcelain transition-colors duration-300">
              View on Amazon <ArrowUpRight size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
            </a>
          </div>
        </div>
      </section>
    </Reveal>
  );
}
